<div>
  <h2 class="no-margin-t">Enter OTP</h2>

  <p class="sub-head">
    {{ providerResponse }}

    <!-- <span class="text-primary">
      "{{loggedInUserEmail.username.substr(0, 4) + '*****' + loggedInUserEmail.username.substr(-2)}}"
    </span> -->
  </p>

  <form>
    <input
      class="otp"
      type="number"
      (input)="digitValidate($event)"
      (keyup)="tabChange(1)"
      maxlength="1"
    />
    <input
      class="otp"
      type="number"
      (input)="digitValidate($event)"
      (keyup)="tabChange(2)"
      maxlength="1"
    />
    <input
      class="otp"
      type="number"
      (input)="digitValidate($event)"
      (keyup)="tabChange(3)"
      maxlength="1"
    />
    <input
      class="otp"
      type="number"
      (input)="digitValidate($event)"
      (keyup)="tabChange(4)"
      maxlength="1"
    />
    <input
      class="otp"
      type="number"
      (input)="digitValidate($event)"
      (keyup)="tabChange(5)"
      maxlength="1"
    />
    <input
      class="otp"
      type="number"
      (input)="digitValidate($event)"
      (keyup)="tabChange(6)"
      maxlength="1"
    />
  </form>

  <button
    class="btn btn__primary btn__lg login__button"
    style="margin-top: 20px"
    (click)="sendOTP()"
  >
    Verify
  </button>

  <p
    class="no-margin-b text-gray text__default mt-2"
    style="text-align: center"
  >
    Didn't get a code?
    <span
      class="text-primary text__default cursor-pointer"
      (click)="resendOTP()"
      style="cursor: pointer"
      >Resend Code</span
    >
  </p>
</div>
